import { Injectable } from '@angular/core';
import { IStepBackConfig, IAppSession } from '../../core/models/app.model';
import { EAPP_FLOWS } from '../../core/enums/app.enum';
import { APP_ROUTES as ROUTES } from '../../app.routes';
import { EONBOARDING_STEPS } from '../../core/enums/onboarding.enum';
import { ICustomerValidate } from '../../core/models/customer.model';
import { EVALIDATION_STATUS as STATUS, EVALIDATION_COMPLETE } from '../../core/enums/customer.enum';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  constructor() {}

  public setStepBackConfig(newCurrentFlow, step): IStepBackConfig {
    switch (newCurrentFlow) {
      case EAPP_FLOWS.AUTH:
        step = --step;
        return { newCurrentFlow, newStep: step };

      case EAPP_FLOWS.ONBOARDING:
        step = step > EONBOARDING_STEPS.USER_INFO ? --step : step;
        return { newCurrentFlow, newStep: step };

      case EAPP_FLOWS.PAYMENT:
        step = step > EONBOARDING_STEPS.USER_INFO ? --step : step;
        newCurrentFlow = step === EONBOARDING_STEPS.USER_INFO ? EAPP_FLOWS.SCORE : newCurrentFlow;
        return { newCurrentFlow, newStep: step };

      default:
        return { newCurrentFlow, newStep: step };
    }
  }

  public handleCustomerSession(
    validation: ICustomerValidate,
    session: IAppSession
  ): {
    route: string;
    step: number;
    re_validation: boolean;
    error?: boolean;
  } {
    const { is_customer } = session;
    const {
      validation_status,
      validator_completed,
      has_card,
      can_request_loan,
      has_payment_capacity,
      can_request_validator,
      can_aggregator_capacity,
    } = validation as ICustomerValidate;

    if (!can_request_loan && !can_request_validator && !can_aggregator_capacity && !is_customer) {
      return {
        route: ROUTES.ERRORS,
        step: EONBOARDING_STEPS.USER_INFO,
        re_validation: false,
        error: true,
      };
    }

    if (!can_request_loan && !can_request_validator && !can_aggregator_capacity && !!is_customer) {
      return {
        route: ROUTES.ERRORS,
        step: EONBOARDING_STEPS.PAYMENT_PLAN,
        re_validation: false,
        error: true,
      };
    }

    if (validation_status === STATUS.PENDING && !can_request_validator) {
      return {
        route: ROUTES.CALCULATE,
        step: EONBOARDING_STEPS.PAYMENT_PLAN,
        re_validation: false,
      };
    }

    if (validation_status === STATUS.PENDING && !is_customer && !!can_request_validator) {
      return {
        route: ROUTES.ONBOARDING,
        step: EONBOARDING_STEPS.USER_INFO,
        re_validation: false,
      };
    }

    if (validation_status === STATUS.APPROVED && !!is_customer && !!can_request_validator) {
      return {
        route: ROUTES.CALCULATE,
        step: EONBOARDING_STEPS.PAYMENT_PLAN,
        re_validation: true,
      };
    }

    if (validation_status === STATUS.APPROVED && !can_request_validator && !has_payment_capacity) {
      return {
        route: ROUTES.ERRORS,
        step: EONBOARDING_STEPS.USER_INFO,
        re_validation: false,
        error: true,
      };
    }

    if (
      validation_status === STATUS.REJECTED &&
      validator_completed === EVALIDATION_COMPLETE.BURO &&
      !!can_request_validator &&
      !is_customer
    ) {
      return {
        route: ROUTES.ONBOARDING,
        step: EONBOARDING_STEPS.USER_INFO,
        re_validation: false,
      };
    }

    if (
      validation_status === STATUS.REJECTED &&
      validator_completed === EVALIDATION_COMPLETE.BURO &&
      !!can_request_validator
    ) {
      return {
        route: ROUTES.CALCULATE,
        step: EONBOARDING_STEPS.PAYMENT_PLAN,
        re_validation: true,
      };
    }

    if (
      validation_status === STATUS.REJECTED &&
      validator_completed === EVALIDATION_COMPLETE.BURO &&
      !can_request_validator
    ) {
      return {
        route: ROUTES.SCORE,
        step: EONBOARDING_STEPS.PAYMENT_PLAN,
        re_validation: true,
      };
    }

    if (
      validation_status === STATUS.REJECTED &&
      validator_completed === EVALIDATION_COMPLETE.KEY_NUA &&
      !!can_request_validator
    ) {
      return {
        route: ROUTES.SCORE,
        step: EONBOARDING_STEPS.PAYMENT_PLAN,
        re_validation: false,
      };
    }

    if (
      validation_status === STATUS.REJECTED &&
      validator_completed === EVALIDATION_COMPLETE.KEY_NUA &&
      !can_request_validator
    ) {
      return {
        route: ROUTES.SCORE,
        step: EONBOARDING_STEPS.PAYMENT_PLAN,
        re_validation: false,
      };
    }

    if (validation_status === STATUS.ERROR && !can_request_validator && !is_customer) {
      return {
        route: ROUTES.ONBOARDING,
        step: EONBOARDING_STEPS.USER_INFO,
        re_validation: false,
        error: true,
      };
    }

    if (validation_status === STATUS.ERROR && can_request_validator && !is_customer) {
      return {
        route: ROUTES.ONBOARDING,
        step: EONBOARDING_STEPS.USER_INFO,
        re_validation: false,
      };
    }

    if (validation_status === STATUS.ERROR && !can_request_validator && is_customer) {
      return {
        route: ROUTES.ERRORS,
        step: EONBOARDING_STEPS.PAYMENT_PLAN,
        re_validation: false,
        error: true,
      };
    }

    if (validation_status === STATUS.ERROR && can_request_validator && is_customer) {
      return {
        route: ROUTES.CALCULATE,
        step: EONBOARDING_STEPS.PAYMENT_PLAN,
        re_validation: true,
      };
    }

    return {
      route: ROUTES.CALCULATE,
      step: EONBOARDING_STEPS.PAYMENT_PLAN,
      re_validation: false,
    };
  }
}
